import IWizardStep from '../../../../interfaces/IWizardStep';
import WizardButton from '../../components/WizardButton';
import { WizardContent } from '../../components/WizardContent';
import { WizardSecodaryTitle } from '../../components/WizardSecodaryTitle';
import { WizardTitle } from '../../components/WizardTitle';
import { useEffect, useState } from 'react';

interface ErrorProps extends IWizardStep {}

const Error = (props: ErrorProps) => {
  const [isDark, setIsDark] = useState(false);

  useEffect(() => {
    const darkMode = localStorage.getItem('isDark') === 'true';
    setIsDark(darkMode);
  }, []);

  const handleSubmit = async () => {
    props.setStep(10, { ...props.medicalCertificate });
  };

  return (
    <WizardContent style={{ height: '100%', color: '#fff' }}>
      <WizardTitle
        style={{ backgroundColor: 'rgb(200, 50, 50)', fontSize: '1.6rem', borderRadius: '8px', padding: '0px 1px' }}
      >
        Sobreposição de Período
      </WizardTitle>
      <WizardSecodaryTitle style={{ color: isDark ? '#fff' : '#333' }}>
        Existe um documento vigente neste período. Por favor, confirme se a data do documento está correta.
      </WizardSecodaryTitle>
      <br />
      <WizardButton onClick={handleSubmit} sx={{ marginTop: '60px', backgroundColor: 'rgb(32, 144, 136)' }}>
        Voltar
      </WizardButton>
    </WizardContent>
  );
};

export default Error;
